export default __webpack_public_path__ + "static/media/icon_sliced_chart.dc27ef91.svg";